import React, {Component} from 'react';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Link} from "react-router-dom";
import betaLogo from '../images/alumsumlogotm.png';
import Menu from '../components/Menu/Menu';
// import './refinancemenu.scss'
import '../refinance/refinance.css';

class Payment extends Component {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    constructor(props){
        super(props);
        const {cookies} = props;
        this.state = {
            csrfToken: cookies.get('XSRF-TOKEN'),
            isLoaded: false
        }
    }

    async componentDidMount() { 
        await fetch('/alumsum/users', {credentials: 'include'})
            .then(async response => response.json())
            .then(data => this.setState({userInfo: data, isLoaded: true})
        );
    }

    render() {
        const {isLoaded} = this.state;
        if (isLoaded) {
            return(
                <div className="refinanceContainer">
                    <div className="app-content display-flex h-100">
                        <Menu data={this.state}></Menu>
                        <div id="main-content" className="main-container wd-100">
                            <Link to="/alumsum/dashboard"><img src={betaLogo} alt="logo" className="responsiveLogo"/></Link>
                            <div className="textWindow">
                                <div className="introText">
                                    <h5>This page coming soon!</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="refinanceContainer"><h3>Loading...</h3></div>
            );
        }
    }
}

export default withCookies(Payment);